import { cookiesGlobal } from "../App";
import { HttpUrls } from "../global/http_url";

const getProjectReportAPI = async (id) => {
    const token = cookiesGlobal.get('auth');
    try {
        const response = await fetch(`${HttpUrls.getProjectReports}/${id}`, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": token,
            },
            method: 'GET',
        });
        const responseData = await response.json();
        if (response.status === 200) {
            return {
                statusCode: responseData.status,
                response: responseData['data'],
            }
        } else {
            return {
                statusCode: response.status,
                response: responseData['message'],
            }
        }
    } catch (e) {
        return {
            statusCode: 505,
            response: 'Intertnet Connection',
        }
    }
}

export { getProjectReportAPI };
